module.exports = __webpack_public_path__ + "img/mp4.dc449e14.png";